module.exports = __webpack_public_path__ + "img/BINDI 4 BW.98f7740.svg";